// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__Zd5Qo","loading":"Loading_loading__0ZbO9","spin":"Loading_spin__SU567"};